/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Информация об избранном договоре
 */
export interface WageContractFavoriteWeb {
  /** Пользовательское имя договора */
  name?: string;

  /** Признак избранного договора */
  favorite?: boolean;
}

/**
 * Стандартный объект ошибки
 */
export interface DefaultExceptionResponse {
  /** Тип проблемы. Внутренний тип ошибки микросервиса Договоры */
  type?: string;

  /** Описание логической ошибки, возникшей в процессе работы */
  title?: string;

  /**
   * Код состояния HTTP ( [RFC7231], раздел 6 ) созданный исходным сервером
   * @format int32
   * @example 400
   */
  status?: number;

  /** Удобочитаемое объяснение проблемы */
  detail?: string;
}

/**
 * Список тарифных планов
 */
export interface WageTariffPlanListWeb {
  data?: WageTariffPlanWeb[];
}

/**
 * Сведения о тарифном плане в справочнике для сотрудника банка
 */
export interface WageTariffPlanWeb {
  name?: string;
  description?: string;
  absId?: string;
}

/**
 * Карточный продукт
 */
export interface WageCardProductWeb {
  currency: string;
  name: string;
  absId: string;
  isActive: boolean;
}

/**
 * Список договоров для АРМ Администратора
 */
export interface WageContractAdminList {
  data?: WageContractAdminWeb[];
}

/**
 * Сведения о договоре зарплатного проекта для сотрудника банка
 */
export interface WageContractAdminWeb {
  /**
   * Идентификатор ЗП договора
   * @format uuid
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id?: string;

  /**
   * Идентификатор ЗП договора в АБС ЦФТ
   * @example 44625146552
   */
  contractAbsId?: string;

  /**
   * Номер ЗП договора
   * @example 233500-4723
   */
  contractNumber?: string;

  /**
   * Дата открытия договора
   * @format date-time
   * @example "2023-10-17T19:00:00.000Z"
   */
  contractDate?: string;

  /**
   * Код тарифного плана ЗП договора
   * @example 31
   */
  tariffPlanCode?: string;

  /**
   * Название тарифного плана ЗП договора
   * @example Дебетовая карта "Зарплатный максимум"
   */
  tariffPlan?: string;
  cardProduct?: WageCardProductWeb[];
  cardIssuingTariff?: number;

  /**
   * Процент комиссии за зачисление на счета сотрудников
   * @example 1
   */
  commission?: number;

  /**
   * Счет для зачисления денежных средств на счета работников
   * @example 40823810235000027655
   */
  account?: string;

  /**
   * Счет банка для перечисления комиссии
   * @example 47423810235000027642
   */
  accCommission?: string;

  /**
   * Название договора, данное ему пользователем
   * @example Основной
   */
  name?: string;

  /**
   * Флаг избранного договора
   * @example false
   */
  isFavorite?: boolean;

  /**
   * Дата закрытия договора
   * @format date-time
   * @example "2023-11-17T19:00:00.000Z"
   */
  contractCloseDate?: string;

  /**
   * Дата фактического закрытия договора
   * @format date-time
   * @example "2023-11-15T19:00:00.000Z"
   */
  contractFactCloseDate?: string;
  contractType?: string;

  /**
   * Вид ЗП договора (код)
   * @example 1
   */
  salaryContractType?: string;
}

/**
 * Список карточных продуктов
 */
export interface WageCardProductAdminListWeb {
  data?: WageCardProductAdminWeb[];
}

/**
 * Карточный продукт в справочнике для сотрудника банка
 */
export interface WageCardProductAdminWeb {
  absId?: string;
  name?: string;
  paymentSystemCode?: string;
  paymentSystemDescription?: string;
  currency?: string;
  description?: string;
  isActive?: boolean;
}

/**
 * Список договоров
 */
export interface WageContractList {
  data?: WageContractWeb[];
}

/**
 * Сведения о договоре зарплатного проекта для клиентского UI
 */
export interface WageContractWeb {
  /**
   * Идентификатор ЗП договора
   * @format uuid
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id?: string;

  /**
   * Идентификатор ЗП договора в АБС ЦФТ
   * @example 44625146552
   */
  contractAbsId?: string;

  /**
   * Номер ЗП договора
   * @example 233500-4723
   */
  contractNumber?: string;

  /**
   * Дата открытия договора
   * @format date-time
   * @example "2023-10-17T19:00:00.000Z"
   */
  contractDate?: string;

  /**
   * Код тарифного плана ЗП договора
   * @example 31
   */
  tariffPlanCode?: string;

  /**
   * Название тарифного плана ЗП договора
   * @example Дебетовая карта "Зарплатный максимум"
   */
  tariffPlan?: string;
  cardProduct?: WageCardProductWeb[];
  cardIssuingTariff?: number;

  /**
   * Процент комиссии за зачисление на счета сотрудников
   * @example 1
   */
  commission?: number;

  /**
   * Счет для зачисления денежных средств на счета работников
   * @example 40823810235000027655
   */
  account?: string;

  /**
   * Счет банка для перечисления комиссии
   * @example 47423810235000027642
   */
  accCommission?: string;

  /**
   * Название договора, данное ему пользователем
   * @example Основной
   */
  name?: string;

  /**
   * Флаг избранного договора
   * @example false
   */
  isFavorite?: boolean;

  /**
   * ИНН подразделения банка
   * @example 7725114488
   */
  branchINN?: string;

  /**
   * КПП подразделения банка
   * @example 561043001
   */
  branchKPP?: string;

  /**
   * БИК банка
   * @example 045354816
   */
  bankBIC?: string;

  /**
   * Наименование подразделения банка
   * @example дополнительный офис Оренбургского РФ АО "Россельхозбанк" №3349/5/03
   */
  bankName?: string;

  /**
   * Корсчет банка
   * @example 30101810500000000674
   */
  corrAcc?: string;
}

/**
 * Заявка на подключение ЗП
 */
export interface WageContractClaimWeb {
  /**
   * Идентификатор заявки (записи в БД)
   * @example 9b370016-30d4-4643-8416-6f5de1950f80
   */
  id: string;

  /**
   * Дата заявки
   * @example "2007-12-03T00:00:00.000Z"
   */
  date: string;

  /**
   * Идентификатор клиента (ЮЛ) в АБС ЦФТ
   * @example 7754528945
   */
  clientId: string;

  /**
   * ИНН клиента (ЮЛ)
   * @example 6648725784
   */
  clientInn: string;

  /**
   * Величина коммисси на перевод ЗП
   * @example 0.5
   */
  commission: string;

  /**
   * Идентификатор/название тарифного плана ЗП
   * @example Зарплатный статус
   */
  tariffPlan: string;

  /**
   * Статус заявки/подписания
   * @example SIGNED
   */
  status: "PREPARED" | "PARTIAL_SIGNED" | "SIGNED" | "SENT" | "CLOSED";

  /**
   * Может ли текущий пользователь подписать данную заявку
   * @example true
   */
  signAvailable: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Зарплатный проект. Микросервис Договоры
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-salary-contracts.ndbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_WAGE <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=85998056)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Договоры
     * @name Mark
     * @summary Отметка договора избранным
     * @request POST:/api/salary-contracts/v1/external/contract/{contractId}/mark-favorite
     */
    mark: (
      contractId: string,
      data: WageContractFavoriteWeb,
      params: RequestParams = {}
    ) =>
      this.request<void, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractId}/mark-favorite`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name TransferToEmployeePrint
     * @summary Печать реквизитов для зачисления на карты
     * @request GET:/api/salary-contracts/v1/external/contract/{contractAbsId}/print-transfer-to-employee
     */
    transferToEmployeePrint: (
      contractAbsId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractAbsId}/print-transfer-to-employee`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name TransferCommissionPrint
     * @summary Печать реквизитов для перевода комиссии за зачисление зарплаты
     * @request GET:/api/salary-contracts/v1/external/contract/{contractAbsId}/print-transfer-commission
     */
    transferCommissionPrint: (
      contractAbsId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractAbsId}/print-transfer-commission`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name CardIssuingCommissionPrint
     * @summary Печать реквизитов для перевода комиссии за выпуск карт
     * @request GET:/api/salary-contracts/v1/external/contract/{contractAbsId}/print-card-issuing-commission
     */
    cardIssuingCommissionPrint: (
      contractAbsId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractAbsId}/print-card-issuing-commission`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name TransferToEmployeeSendMail
     * @summary Отправка на email реквизитов для зачисления на карты
     * @request GET:/api/salary-contracts/v1/external/contract/{contractAbsId}/mail-transfer-to-employee
     */
    transferToEmployeeSendMail: (
      contractAbsId: string,
      query: { mailto: string },
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractAbsId}/mail-transfer-to-employee`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name TransferCommissionSendMail
     * @summary Отправка на email реквизитов для перевода комиссии за зачисление зарплаты
     * @request GET:/api/salary-contracts/v1/external/contract/{contractAbsId}/mail-transfer-commission
     */
    transferCommissionSendMail: (
      contractAbsId: string,
      query: { mailto: string },
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractAbsId}/mail-transfer-commission`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name CardIssuingCommissionSendMail
     * @summary Отправка на email реквизитов для перевода комиссии за выпуск карт
     * @request GET:/api/salary-contracts/v1/external/contract/{contractAbsId}/mail-card-issuing-commission
     */
    cardIssuingCommissionSendMail: (
      contractAbsId: string,
      query: { mailto: string },
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/contract/${contractAbsId}/mail-card-issuing-commission`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на подключение Зарплатного проекта
     * @name GetConfirmTypes
     * @summary Эндпоинт для получения доступных типов подтверждения у текущего Клиента.
     * @request GET:/api/salary-contracts/v1/external/confirm-types
     */
    getConfirmTypes: (params: RequestParams = {}) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/confirm-types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name GetClientContracts
     * @summary Список договоров клиента
     * @request GET:/api/salary-contracts/v1/external/client/{clientAbsId}/contracts
     */
    getClientContracts: (clientAbsId: string, params: RequestParams = {}) =>
      this.request<WageContractList, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/client/${clientAbsId}/contracts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на подключение Зарплатного проекта
     * @name GetClientClaim
     * @summary Получение информации о заявке текущего клиента
     * @request GET:/api/salary-contracts/v1/external/claim
     */
    getClientClaim: (params: RequestParams = {}) =>
      this.request<WageContractClaimWeb, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/claim`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на подключение Зарплатного проекта
     * @name GetCcbString
     * @summary Эндпоинт для получения строки ККБ. Проксирует запрос в МС Подтверждения
     * @request GET:/api/salary-contracts/v1/external/claim/{claimId}/build-ccb
     */
    getCcbString: (claimId: string, params: RequestParams = {}) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-contracts/v1/external/claim/${claimId}/build-ccb`,
        method: "GET",
        ...params,
      }),
  };
}

export const api = new Api();
